import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href", "width", "x", "y"]
const _hoisted_2 = ["x", "y", "width"]
const _hoisted_3 = { key: 1 }

import { Block, BlockWithUUID } from "../utils/block";
import { computed, ref, Ref } from "vue";
import { useI18n } from "vue-i18n";
import Tooltip from "./tooltip/Tooltip.vue";
import BlockDescription from "./tooltip/BlockDescription.vue";
import MatterSelect from "./MatterSelect.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    x: null,
    y: null,
    block: null,
    updateBlock: null,
    showTooltip: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  x: number;
  y: number;
  block: Block | BlockWithUUID;
  updateBlock: (
    updater: <T extends Block | BlockWithUUID>(block: T) => T
  ) => void;
  showTooltip?: boolean;
}

const { t } = useI18n();


const blockElem: Ref<HTMLElement | null> = ref(null);
const src = computed(() => props.block.design.imageSrc);
const displayName = computed(() => props.block.design.displayName);
const _y = computed(
  () => -props.block.design.height + props.y + props.block.design.bottomAnchor
);
const elements = computed(() => {
  const tDisplayName = t(displayName.value);
  const regExp = /<([^>]+)>/g;
  let cursor = 0;
  let execResult = regExp.exec(tDisplayName);
  const elements: (
    | { type: "options"; items: readonly string[] }
    | { type: "text"; text: string }
  )[] = [];
  while (execResult !== null && cursor < tDisplayName.length) {
    const textBetweenSelect = tDisplayName.substring(cursor, execResult.index);
    if (textBetweenSelect !== "") {
      elements.push({ type: "text", text: textBetweenSelect });
    }
    if (props.block.params === null) {
      throw new Error(
        `Placeholder is not supported in the block ${t(
          props.block.design.displayName
        )}`
      );
    }
    const paramName = execResult[1].split(",")[0];
    if (!(paramName in props.block.params)) {
      throw new Error(
        `Placeholder ${paramName} is not supported in the block ${t(
          props.block.design.displayName
        )}`
      );
    }
    elements.push({
      type: "options",
      items: props.block.params[paramName].list,
    });
    cursor = execResult.index + execResult[0].length;
    execResult = regExp.exec(tDisplayName);
  }
  if (cursor < tDisplayName.length - 1) {
    elements.push({
      type: "text",
      text: tDisplayName.substring(cursor),
    });
  }
  return elements;
});

// todo: support for multiple options
const paramValue = computed({
  get() {
    const params = props.block.params;
    if (params === null) return "";
    return params[Object.keys(params)[0]].value;
  },
  set(value: string) {
    props.updateBlock((block) => {
      if (block.params === null) return block;
      block.params[Object.keys(block.params)[0]].value = value;
      return block;
    });
  },
});
const rect: Ref<DOMRect | null> = ref(null);
const showDescription = ref(false);
let enterTimeoutId: number | null = null;
let leaveTimeoutId: number | null = null;
const pointerenter = () => {
  if (leaveTimeoutId !== null) {
    clearTimeout(leaveTimeoutId);
    leaveTimeoutId = null;
  }
  enterTimeoutId = setTimeout(() => {
    enterTimeoutId = null;
    rect.value = blockElem.value?.getBoundingClientRect() ?? null;
    showDescription.value = true;
  }, 300);
};
const pointerleave = () => {
  if (enterTimeoutId !== null) {
    clearTimeout(enterTimeoutId);
    enterTimeoutId = null;
  }
  leaveTimeoutId = setTimeout(() => {
    leaveTimeoutId = null;
    showDescription.value = false;
  }, 100);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", null, [
    _createElementVNode("image", {
      href: _unref(src),
      width: props.block.design.width,
      x: props.x,
      y: _unref(_y)
    }, null, 8, _hoisted_1),
    (_openBlock(), _createElementBlock("foreignObject", {
      x: props.x + props.block.design.marginLeft,
      y: props.y - 30,
      width: 
        props.block.design.width -
        props.block.design.marginLeft -
        props.block.design.marginRight
      ,
      height: 30
    }, [
      _createElementVNode("div", {
        class: "block-inner",
        ref_key: "blockElem",
        ref: blockElem,
        onPointerenter: pointerenter,
        onPointerleave: pointerleave
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(elements), (element, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (element.type === 'options')
              ? (_openBlock(), _createBlock(MatterSelect, {
                  key: 0,
                  modelValue: _unref(paramValue),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(paramValue) ? (paramValue).value = $event : null)),
                  list: element.items
                }, null, 8, ["modelValue", "list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(element.text), 1))
          ], 64))
        }), 128))
      ], 544),
      _createVNode(Tooltip, {
        rect: rect.value,
        show: Boolean(__props.showTooltip) && showDescription.value
      }, {
        default: _withCtx(() => [
          _createVNode(BlockDescription, {
            block: props.block
          }, null, 8, ["block"])
        ]),
        _: 1
      }, 8, ["rect", "show"])
    ], 8, _hoisted_2))
  ]))
}
}

})